import pro6pp from '../../../pro6pp-client';
import getReasonReqParams from '../../../components/letter/form-objects/reason-to-cancel-required.json';
import getReasonNotReqParams from '../../../components/letter/form-objects/reason-to-cancel-not-required.json';
import getIbanParams from '../../../components/letter/form-objects/iban.json';

export default {
  cancellationId: (state) => state.cancellationId,
  getCancellation: (state) => state.cancellation,
  isGuaranteed: (state, getters) => {
    if (true === getters.getCancellation.guaranteedCancellation) {
      return true;
    }
    if (true === getters.getActiveCancellation?.guaranteedCancellation) {
      return true;
    }
    return false;
  },
  getPaymentMethods: (state) => state.paymentMethods,
  getOptionalProduct: (state) => state.optionalProduct,
  getCancellationOptions: (state) => state.cancellationOptions,
  isSetupComplete: (state) => state.setupComplete,
  getSubCancellation: (state) => (index) => state.subCancellations[index],
  getActiveCancellation: (state) => state.activeCancellation,
  getReasonToCancelParameters: state => (state.reasonToCancelRequired ? getReasonReqParams : getReasonNotReqParams),
  getReasonToCancelFormField: state => state.reasonToCancelFormField,
  getFormField: (state) => (name) => {
    if (Object.keys(state.paymentType).includes(name)) {
      return state.paymentType[name];
    }
    if (Object.keys(state.additionalFormFields).includes(name)) {
      return state.additionalFormFieldValues[name];
    }
    if (name === getIbanParams.propertyName) {
      return state.ibanFormField;
    }
    const reason = state.reasonToCancelRequired ? getReasonReqParams.propertyName : getReasonNotReqParams.propertyName;
    if (name === reason) {
      return state.reasonToCancelFormField;
    }

    return state.formFields[name];
  },
  getFormFields: (state) => state.formFields,
  getAdditionalFormFields: (state) => state.additionalFormFields,
  getAdditionalFormField: (state) => (slug) => state.additionalFormFields[slug],
  getAdditionalFormFieldValues: state => state.additionalFormFieldValues,
  getIbanParameters: () => getIbanParams,
  getIbanFormField: state => state.ibanFormField,
  getFormFieldValidityStates: (state) => state.formFieldValidityStates,
  getFormFieldValidityState: (state) => (name) => {
    if (Object.keys(state.paymentTypeValidity).includes(name)) {
      return state.paymentTypeValidity[name];
    }

    return state.formFieldValidityStates[name];
  },
  // eslint-disable-next-line max-len
  isDutchPostcode: (state) => 'customerPostcode' in state.formFields && pro6pp.isDutchPostcode(state.formFields.customerPostcode),
  // eslint-disable-next-line max-len
  isBelgianPostcode: (state) => 'customerPostcode' in state.formFields && pro6pp.isBelgiumPostcode(state.formFields.customerPostcode),
  getPayments: (state) => state.payments,
  getSelectedPaymentId: (state) => state.formFields.product,
  // eslint-disable-next-line max-len
  getSelectedPaymentPrice: (state, getters) => parseInt(state.payments[getters.getSelectedPaymentId]?.price.replace(',', '') ?? 0, 10),
  getPayment: (state) => (id) => state.payments[id],
  isDrawnSignatureRequired: (state) => state.drawnSignatureRequired,
  isReasonToCancelRequired: (state) => state.reasonToCancelRequired,
  getPaymentType: (state) => state.paymentType,
  getPaymentTypeField: (state) => (name) => state.paymentType[name],
  getPaymentTypeValidity: (state) => state.paymentTypeValidity,
  getSignatureData: (state) => state.signatureData,
  showErrors: (state) => state.showErrors,
  showPaymentTypeErrors: (state) => state.showPaymentTypeErrors,
  getInputRef: (state) => (name) => state.inputRefs[name],
  hasInputRef: (state) => (name) => name in state.inputRefs,
  getErrorCount: (state) => {
    let cnt = 0;
    Object.values(state.formFieldValidityStates).forEach((validityState) => {
      cnt += !validityState;
    });
    return cnt;
  },
  getPaymentTypeErrorCount: (state) => {
    let cnt = 0;
    Object.values(state.paymentTypeValidity).forEach(validityState => {
      cnt += !validityState;
    });
    return cnt;
  },
  getClient: (state) => state.client,
  cacheFetch: (state) => (payload) => {
    if (undefined === state.cache[payload.postcode]) {
      return undefined;
    }
    return state.cache[payload.postcode][payload.streetnumber];
  },
  getCache: (state) => state.cache,
  addressIsValid: (state) => state.addressIsValid,
  getCountry: (state) => state.country,
  signatureMode: (state) => state.signatureMode,
  hasDrawnSignature: state => undefined !== state.formFields.customerSignature
    && undefined !== state.signatureData
    && 0 !== state.signatureData.length,
  hasWrittenSignature: state => !!state.formFields.customerFirstName || !!state.formFields.customerLastName,
  hasValidSignature: (state, getters) => {
    if (state.drawnSignatureRequired) return getters.hasDrawnSignature;

    return (getters.hasDrawnSignature || getters.hasWrittenSignature);
  },
  companyName: (state) => {
    try {
      return state.cancellation.companyName;
    } catch (TypeError) {
      return null;
    }
  },
  generic: (state) => state.generic,
  isSignaturePadDefined: state => undefined !== state.adivareSignaturePad,
  cancellationDate: state => state.cancellationDate,
  totalPrice: state => state.totalPrice,
};
